import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getBusinessAppointmentsAction } from '../../../../../actions/businessAppointments';
import { updateOffer } from '../../../../../redux/reducers';
import { businessAppointmentsIsLoadedSelector } from '../../../../../selectors/business/businessAppointmentsIsLoadedSelector';

export function useFilterBusinessAppointmentsMountEffect(): void {
  const dispatch = useDispatch();

  const businessAppointmentsIsLoaded = useSelector(businessAppointmentsIsLoadedSelector);

  useEffect(() => {
    if (!businessAppointmentsIsLoaded) {
      dispatch(getBusinessAppointmentsAction());
    }

    return () => {
      dispatch(updateOffer({ specialty: undefined }));
    };
    // Это эффект только маунта/демаунта компонента
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
}
